import { request } from '../../helpers'

export default {
  async listAppointmentSlots({ expand = [], queryParameters = {} } = {}) {
    return (await request({ url: 'appointment_slots', queryParameters, expand }))
      .data
  },
  async retrieveAppointmentSlot(id, { expand = [], queryParameters = {} } = {}) {
    return (await request({ url: `appointment_slots/${id}`, expand, queryParameters }))
      .data
  },
  async initiateAppointmentSlotPurchase(id, { data = {} } = {}) {
    return (await request({ method: 'POST', url: `appointment_slots/${id}/initiate_purchase`, data }))
      .data
  },
  async registerForAppointment(appointmentId, { data = {} }) {
    return (
      await request({
        method: 'POST',
        url: `/appointment_slots/${appointmentId}/register`,
        data,
      })
    ).data
  },
}
